import React from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import StrengthBanner from "../../Assets/OUR-STRENGTH1.jpg";
import { Link } from "react-router-dom";

const OurStrength = () => {
  return (
    <div>
      <Header />

      {/* Banner Section */}
      <section
        className="container-fluid common_banner"
        style={{
          backgroundImage: `url(${StrengthBanner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="common_title wow fadeInUp">
                <h2>
                  <Link
                    to="/AboutUs"
                    className="text-decoration-none text-white"
                  >
                    ABOUT US
                  </Link>{" "}
                  <span className="text-white">/ Our Strengths</span>
                </h2>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Strengths Section */}
      <section className="container-fluid about_Products_section py-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 wow fadeInUp">
              <h2
                style={{
                  color: "#153fa4",
                  fontSize: "40px",
                  fontWeight: "700",
                  marginBottom: "20px",
                }}
              >
                Our Strengths
              </h2>

              <p>
                At <strong>Khodiyar Industries</strong>, our success is driven
                by a strong foundation of quality, innovation, customer
                satisfaction, and a dedicated workforce. Over the years, we have
                established ourselves as a trusted manufacturer of automobile
                and commercial vehicle glass by consistently delivering products
                that meet the highest industry standards.
              </p>

              <ul
                style={{
                  lineHeight: "2",
                  fontSize: "17px",
                  paddingLeft: "20px",
                }}
              >
                <li>
                  <strong>Experienced Team:</strong> Our skilled professionals
                  and dedicated workforce play a vital role in maintaining
                  superior product quality and operational excellence.
                </li>

                <li>
                  <strong>Advanced Manufacturing Facility:</strong> Equipped
                  with modern machinery and in-house production capabilities, we
                  ensure precision, consistency, and efficiency in every
                  product.
                </li>

                <li>
                  <strong>Quality Assurance:</strong> We follow strict quality
                  control processes to manufacture durable, safe, and
                  high-performance automotive glass products.
                </li>

                <li>
                  <strong>Customized Solutions:</strong> We understand the
                  unique requirements of our customers and provide tailor-made
                  glass solutions that perfectly suit their needs.
                </li>

                <li>
                  <strong>Customer-Centric Approach:</strong> Our commitment to
                  customer satisfaction enables us to build long-lasting
                  relationships based on trust, reliability, and timely service.
                </li>

                <li>
                  <strong>Continuous Innovation:</strong> We constantly adopt
                  new technologies and manufacturing techniques to improve our
                  products and stay ahead in the industry.
                </li>

                <li>
                  <strong>Competitive Pricing:</strong> By maintaining efficient
                  operations and quality-driven processes, we offer premium
                  products at competitive market prices.
                </li>

                <li>
                  <strong>Nationwide Presence:</strong> Our growing client base
                  across India reflects the trust and confidence customers place
                  in the Khodiyar India brand.
                </li>

                <li>
                  <strong>Sustainable Growth:</strong> We focus on responsible
                  manufacturing practices that support environmental
                  sustainability while delivering long-term value to customers.
                </li>
              </ul>

              <p className="mt-4">
                These strengths enable Khodiyar Industries to continue
                delivering innovative, reliable, and high-quality automotive
                glass solutions while maintaining our position as a trusted
                industry partner.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default OurStrength;
